/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Visa_Eb2niw_Point_2_TextInputs */

const en_visa_eb2niw_point_2_text = /** @type {(inputs: Visa_Eb2niw_Point_2_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A strong NIW case usually depends on how the applicant's background, future plans, and supporting evidence are presented together.`)
};

const pt_visa_eb2niw_point_2_text = /** @type {(inputs: Visa_Eb2niw_Point_2_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um caso NIW forte geralmente depende de como a formação do candidato, planos futuros e evidências de apoio são apresentados em conjunto.`)
};

const es_visa_eb2niw_point_2_text = /** @type {(inputs: Visa_Eb2niw_Point_2_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un caso NIW sólido generalmente depende de cómo la formación del solicitante, los planes futuros y la evidencia de respaldo se presentan en conjunto.`)
};

/**
* | output |
* | --- |
* | "A strong NIW case usually depends on how the applicant's background, future plans, and supporting evidence are presented together." |
*
* @param {Visa_Eb2niw_Point_2_TextInputs} inputs
* @param {{ locale?: "en" | "pt" | "es" }} options
* @returns {LocalizedString}
*/
export const visa_eb2niw_point_2_text = /** @type {((inputs?: Visa_Eb2niw_Point_2_TextInputs, options?: { locale?: "en" | "pt" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Visa_Eb2niw_Point_2_TextInputs, { locale?: "en" | "pt" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt") return pt_visa_eb2niw_point_2_text(inputs)
	if (locale === "es") return es_visa_eb2niw_point_2_text(inputs)
	return en_visa_eb2niw_point_2_text(inputs)
});